// Consent lookups against the Clickskeks (CCM19) embedding API, see
// https://www.docs.clickskeks.de/api/javascript-apis/. Gate on the embedding name
// that is listed in the banner, not on the legacy category API: that API only
// reported "statistics" as allowed once every embedding of the purpose was accepted.

function isNeosBackend() {
    return document.body.classList.contains('neos-backend');
}

export function isEmbeddingAccepted(name) {
    if (isNeosBackend()) {
        return true;
    }
    const ccm = window.CCM;
    return !!(ccm && Array.isArray(ccm.acceptedEmbeddings) && ccm.acceptedEmbeddings.some(embedding => embedding && embedding.name === name));
}

export function onEmbeddingAccepted(name, callback, executeInBackend = true) {
    if (isNeosBackend()) {
        if (executeInBackend) {
            callback();
        }
        return;
    }
    if (isEmbeddingAccepted(name)) {
        callback();
        return;
    }
    let done = false;
    const run = () => {
        if (done) {
            return;
        }
        done = true;
        window.removeEventListener('ccm19EmbeddingAccepted', onAccepted);
        window.removeEventListener('ccm19WidgetClosed', onWidgetClosed);
        callback();
    };
    // CCM19 dispatches ccm19EmbeddingAccepted per accepted embedding on every page load
    // (also for stored consent) and ccm19WidgetClosed after a fresh decision.
    const onAccepted = event => {
        if (event.detail && event.detail.name === name) {
            run();
        }
    };
    const onWidgetClosed = () => {
        if (isEmbeddingAccepted(name)) {
            run();
        }
    };
    window.addEventListener('ccm19EmbeddingAccepted', onAccepted);
    window.addEventListener('ccm19WidgetClosed', onWidgetClosed);
}

export function openConsentSettings() {
    if (window.CCM && typeof window.CCM.openWidget === 'function') {
        window.CCM.openWidget();
    }
}
